import { useState } from 'react'
import { Link } from 'react-router-dom'
import {
  Anchor,
  MainMenu,
  MainMenuAvatar,
  FlexSpacer,
  DropdownMenuButton,
  DropdownMenuBody,
  Panel,
  FlexRow,
} from '@epam/loveship'
import { Dropdown, AdaptiveItemProps } from '@epam/uui-components'
import { ReactComponent as HelpIcon } from '@epam/assets/icons/common/notification-help-outline-24.svg'
import { ReactComponent as LogoIcon } from '@epam/assets/icons/common/action-map_pin-24.svg'
import { useUuiContext, UuiContexts } from '@epam/uui-core'
import { ROUTES } from '../../constants/routes'
import { showErrorNotification } from '../../utils/notifications/showErrorNotification'
import { useAppSelector } from '../../hooks/redux/redux'
import { useLogoutMutation } from '../../store'
import { useActions } from '../../hooks/redux/actions'

const RenderAvatar = () => {
  const [logout] = useLogoutMutation()
  const { userInfo: user } = useAppSelector((state) => state.users)
  const { setUserInfo } = useActions()

  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const svc = useUuiContext<UuiContexts>()

  async function handleClickLogout() {
    try {
      setIsLoggingOut(true)
      await logout()
    } catch (error: any) {
      console.log('error: ', error)

      showErrorNotification({
        svc,
        message: `Error on logout: ${error.message}`,
      })
    } finally {
      setIsLoggingOut(false)
      setUserInfo(null)
    }
  }

  return (
    <FlexRow>
      <Anchor
        href={`mailto:OrgSettlementPlatform@epam.com?subject=Feedback on Social Map application`}
      >
        <HelpIcon />
      </Anchor>

      <Dropdown
        renderTarget={(props) => (
          <MainMenuAvatar
            isDropdown
            avatarUrl={user?.picture}
            caption={user?.name}
            {...props}
          />
        )}
        renderBody={(props) => (
          <DropdownMenuBody {...props}>
            {user && (
              <DropdownMenuButton
                isDisabled={isLoggingOut}
                caption="Log out"
                onClick={handleClickLogout}
              />
            )}
          </DropdownMenuBody>
        )}
        placement="bottom-end"
      />
    </FlexRow>
  )
}

const getMenuItems = (): AdaptiveItemProps[] => {
  const goToHomePage = () => {
    window.location.href = ROUTES.HOME
  }

  return [
    {
      id: 'logo',
      priority: 99,
      render: () => (
        <Panel margin="24" key="1">
          <>
            <Link
              to={ROUTES.HOME}
              onClick={goToHomePage}
              style={{
                color: 'white',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'end',
              }}
            >
              <LogoIcon
                fill="white"
                style={{
                  color: 'white',
                  marginRight: '5px',
                }}
              />
              Social Map
            </Link>
          </>
        </Panel>
      ),
    },
    { id: 'flexSpacer', priority: 100, render: () => <FlexSpacer key="2" /> },
    { id: 'avatar', priority: 2, render: () => <RenderAvatar key="3" /> },
  ]
}

export const AppHeader = () => {
  return <MainMenu items={getMenuItems()} />
}
